"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SelectionList: true
};
exports.default = exports.SelectionList = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _ValidationMessage = require("../Forms/_ValidationMessage");
var _InfoBar = require("../InfoBar/InfoBar");
var _Listbox = require("../List/Listbox");
var _BusyIndicator = require("../BusyIndicator/BusyIndicator");
var _listOptions = require("../utils/_listOptions");
var _isString = require("../utils/isString");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _SelectDialogContext = require("./_SelectDialogContext");
var _SelectionFilter = require("./_SelectionFilter");
var _filterType2 = require("./filterType");
var _SelectionList = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SelectionList.css") : void 0);
var _SelectionList2 = require("./SelectionList.types");
Object.keys(_SelectionList2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SelectionList2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SelectionList2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-selection-list';
const SelectionList = exports.SelectionList = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _a;
  const {
      className,
      selectionFilterProps,
      filterLabel,
      filterIconProps,
      filterDropdownItemKey,
      filterDropdownItemText,
      filterDropdownOptions,
      filterDropdownRef,
      filterDropdownLabel,
      filterDropdownSelectedKey,
      filterDropdownOnSelect,
      filterDropdownComponentProps,
      filterDropdownDataRendering,
      groupBy,
      infinite,
      infobarProps,
      isListEmpty,
      isLoading,
      itemCountScreenReaderLabel,
      status,
      listboxHeight = '450px',
      listboxProps,
      loadingMessage,
      mruOptions,
      mruTitle,
      noResultsMsg,
      filterType: _filterType = 'auto',
      manualFilterButtonProps: _manualFilterButtonProps,
      onFilter,
      options,
      otherGroupHeader,
      searchPlacement = 'top'
    } = props,
    otherProps = __rest(props, ["className", "selectionFilterProps", "filterLabel", "filterIconProps", "filterDropdownItemKey", "filterDropdownItemText", "filterDropdownOptions", "filterDropdownRef", "filterDropdownLabel", "filterDropdownSelectedKey", "filterDropdownOnSelect", "filterDropdownComponentProps", "filterDropdownDataRendering", "groupBy", "infinite", "infobarProps", "isListEmpty", "isLoading", "itemCountScreenReaderLabel", "status", "listboxHeight", "listboxProps", "loadingMessage", "mruOptions", "mruTitle", "noResultsMsg", "filterType", "manualFilterButtonProps", "onFilter", "options", "otherGroupHeader", "searchPlacement"]);
  const classnames = _bind.default.bind(_SelectionList.default);
  const {
    validationMessage
  } = (0, _react.useContext)(_SelectDialogContext.SelectDialogContext) || {};
  const screenReaderContentId = (0, _useUniqueId.default)();
  const listRef = (0, _react.useRef)(null);
  const getNoResultsScreenReaderText = () => {
    if (isListEmpty && noResultsMsg) {
      if ((0, _isString.isString)(noResultsMsg)) {
        return noResultsMsg;
      }
      return `${noResultsMsg === null || noResultsMsg === void 0 ? void 0 : noResultsMsg.title}, ${noResultsMsg === null || noResultsMsg === void 0 ? void 0 : noResultsMsg.description}`;
    }
    return '';
  };
  const screenReaderStatus = isLoading ? loadingMessage : getNoResultsScreenReaderText();
  const screenReaderContent = /*#__PURE__*/_react.default.createElement("span", {
    className: classnames(`${CSS_BLOCK}--screen-reader-only`),
    id: screenReaderContentId,
    role: "status"
  }, (screenReaderStatus === null || screenReaderStatus === void 0 ? void 0 : screenReaderStatus.length) && screenReaderStatus.length > 0 && screenReaderStatus);
  const noResults = () => {
    if (!noResultsMsg) return null;
    const content = (0, _isString.isString)(noResultsMsg) ? (/*#__PURE__*/_react.default.createElement("div", {
      className: classnames(`${CSS_BLOCK}__no-results-title`)
    }, noResultsMsg)) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: classnames(`${CSS_BLOCK}__no-results-title`)
    }, noResultsMsg.title), noResultsMsg.description && (/*#__PURE__*/_react.default.createElement("div", {
      className: classnames(`${CSS_BLOCK}__no-results-description`)
    }, noResultsMsg.description)), screenReaderContent));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classnames(`${CSS_BLOCK}__no-results-container`)
    }, content);
  };
  const loadingIndicator = () => (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__loading-container`)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__loading`)
  }, /*#__PURE__*/_react.default.createElement(_BusyIndicator.BusyIndicator, {
    message: `${loadingMessage}`,
    type: "inline",
    visible: true
  })), screenReaderContent));
  const {
    isUsingGroups,
    newOptions,
    groupLabelRenderer
  } = (0, _listOptions.getOptionsList)({
    options,
    mruOptions,
    groupBy,
    mruTitle,
    otherGroupHeader
  });
  const listComponent = /*#__PURE__*/_react.default.createElement(_Listbox.Listbox, Object.assign({
    maxHeight: listboxHeight
  }, listboxProps, {
    className: classnames(`${CSS_BLOCK}__list-box`, listboxProps === null || listboxProps === void 0 ? void 0 : listboxProps.className),
    groupLabelRenderer: isUsingGroups ? groupLabelRenderer : undefined,
    infinite: infinite,
    options: isUsingGroups ? newOptions : newOptions[0],
    ref: listRef
  }));
  const listToRender = isListEmpty ? noResults() : listComponent;
  const handleInputKeyDown = event => {
    switch ((0, _keycode.default)(event)) {
      case 'down':
        {
          // move focus to the list
          if (listRef === null || listRef === void 0 ? void 0 : listRef.current) {
            setTimeout(() => {
              var _a;
              // focus target, we should allow a delay before it is called.
              (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 0);
          }
          break;
        }
      default:
    }
  };
  const itemCount = ((options === null || options === void 0 ? void 0 : options.length) || 0) + ((mruOptions === null || mruOptions === void 0 ? void 0 : mruOptions.length) || 0);
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    className: classnames(CSS_BLOCK, className, {
      [`${CSS_BLOCK}--bottom`]: searchPlacement === 'bottom'
    }),
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__search-container`, {
      [`${CSS_BLOCK}__search-container--bottom`]: searchPlacement === 'bottom'
    })
  }, /*#__PURE__*/_react.default.createElement(_SelectionFilter.SelectionFilter, Object.assign({
    filterLabel: filterLabel,
    itemCount: itemCount,
    itemCountScreenReaderLabel: itemCountScreenReaderLabel,
    noItemsScreenReaderLabel: (getNoResultsScreenReaderText === null || getNoResultsScreenReaderText === void 0 ? void 0 : getNoResultsScreenReaderText()) || ''
  }, selectionFilterProps, {
    className: classnames(`${CSS_BLOCK}__search-field`, selectionFilterProps === null || selectionFilterProps === void 0 ? void 0 : selectionFilterProps.className),
    inputProps: Object.assign(Object.assign({
      spellCheck: 'false',
      autoCorrect: 'off',
      autoCapitalize: 'off'
    }, selectionFilterProps === null || selectionFilterProps === void 0 ? void 0 : selectionFilterProps.inputProps), {
      onKeyDown: (0, _chainFunction.default)(handleInputKeyDown, (_a = selectionFilterProps === null || selectionFilterProps === void 0 ? void 0 : selectionFilterProps.inputProps) === null || _a === void 0 ? void 0 : _a.onKeyDown)
    }),
    filterIconProps: filterIconProps,
    filterDropdownItemKey: filterDropdownItemKey,
    filterDropdownItemText: filterDropdownItemText,
    filterDropdownOptions: filterDropdownOptions,
    filterDropdownRef: filterDropdownRef,
    filterDropdownLabel: filterDropdownLabel,
    filterDropdownSelectedKey: filterDropdownSelectedKey,
    filterDropdownOnSelect: filterDropdownOnSelect,
    filterDropdownComponentProps: filterDropdownComponentProps,
    filterDropdownDataRendering: filterDropdownDataRendering,
    onFilter: onFilter
  }, (0, _filterType2.buildFilterTypeProps)(props)))), validationMessage && validationMessage.state && validationMessage.text && (/*#__PURE__*/_react.default.createElement(_ValidationMessage.ValidationMessage, {
    inPopper: true,
    state: validationMessage.state,
    text: validationMessage.text,
    className: classnames(`${CSS_BLOCK}__validation`)
  })), status && (/*#__PURE__*/_react.default.createElement(_InfoBar.InfoBar, Object.assign({}, infobarProps, {
    className: classnames(`${CSS_BLOCK}__infobar`, infobarProps === null || infobarProps === void 0 ? void 0 : infobarProps.className),
    info: status
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__list-container`, {
      [`${CSS_BLOCK}__list-container--top`]: searchPlacement === 'bottom'
    }),
    style: {
      // stylelint-disable-next-line value-keyword-case
      maxHeight: (listboxProps === null || listboxProps === void 0 ? void 0 : listboxProps.maxHeight) || listboxHeight
    }
  }, isLoading ? loadingIndicator() : listToRender));
});
SelectionList.displayName = 'SelectionList';
var _default = exports.default = SelectionList;